import Vue from "vue";
import VueMultianalytics from "vue-multianalytics";

export default {

    mounted() {
        this.configureMixpanel();
    },
    methods: {
        configureMixpanel() {
            var mixpanelConfig = {
                token:  process.env.VUE_APP_MIXPANEL_TOKEN,
            };

            Vue.use(VueMultianalytics, {
                modules: {
                    mixpanel: mixpanelConfig
                }
            });
        },
        trackEvent(event, additionalProperties, userName) {
            event = `${event}`;
            let baseProperties = {
                timestamp: new Date().toUTCString(),
                event
            };
            if(userName){
                baseProperties.userId = userName;
                baseProperties.user_id = userName;
                baseProperties.distinct_id = userName;
            }else{
                baseProperties.userId = process.env.VUE_APP_MIXPANEL_UNAUTHENTICATED_USER;
                baseProperties.user_id = process.env.VUE_APP_MIXPANEL_UNAUTHENTICATED_USER;
                baseProperties.distinct_id = process.env.VUE_APP_MIXPANEL_UNAUTHENTICATED_USER;
            }

            this.$ma.trackEvent({
                action: event,
                properties: Object.assign(baseProperties, additionalProperties)
            });
        }
    },
}